import React from 'react';

function MemberIcon(props: React.SVGAttributes<{}>) {
    return (
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.5 14.75C13.5 13.1587 12.8679 11.6326 11.7426 10.5074C10.6174 9.38214 9.0913 8.75 7.5 8.75M7.5 8.75C5.9087 8.75 4.38258 9.38214 3.25736 10.5074C2.13214 11.6326 1.5 13.1587 1.5 14.75M7.5 8.75C9.57107 8.75 11.25 7.07107 11.25 5C11.25 2.92893 9.57107 1.25 7.5 1.25C5.42893 1.25 3.75 2.92893 3.75 5C3.75 7.07107 5.42893 8.75 7.5 8.75ZM16.5 14.0001C16.5 11.4726 15 9.12515 13.5 8.00015C13.9931 7.63022 14.3874 7.14446 14.648 6.58585C14.9086 6.02723 15.0274 5.413 14.9941 4.7975C14.9607 4.182 14.7761 3.58421 14.4566 3.05705C14.1372 2.52988 13.6927 2.08959 13.1625 1.77515"
                stroke="#0E192F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default MemberIcon;
